import vestingOptions from 'constants/vestingOptions';

export const getVestingMonths = (months: Number) =>
  vestingOptions.find((option: any) => option.value === Number(months))?.text;
